import script from "./EstabelecimentoDashPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EstabelecimentoDashPage.vue?vue&type=script&setup=true&lang=js"

import "./EstabelecimentoDashPage.vue?vue&type=style&index=0&id=d4d8eeb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4d8eeb0"]])

export default __exports__